import object from 'helpers/object'


const _initialState = {
  data: [],
  pages: 0,
  activePageId: 1,
  isFetching: false,
}

export const initialState = _initialState

export const setData = (state, payload) =>
  object.setIn(state, [ 'data' ], payload)

export const setPages = (state, payload) =>
  object.setIn(state, [ 'pages' ], payload)

export const setActivePageId = (state, payload) =>
  object.setIn(state, [ 'activePageId' ], payload)

export const setFetching = (state, payload) =>
  object.setIn(state, [ 'isFetching' ], payload)
